module.exports = __webpack_public_path__ + "img/website-service-01.a2d1fb79.png";